import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Home from "./component/home/Home";
import Navbar from "./component/header/Navbar";
import About from "./component/about/About";
import OurTeam from "./component/our-team/OurTeam";
import ContactPage from "./component/contactUs/ContactPage";
import Blogs from "./component/Blog/Blogs";
import BlogHome from "./component/Blog/BlogHome";
import Carrer from "./component/carrer/Carrer";
import OurWork from "component/our-work/OurWork";
import Project from "component/project/Project";
import PortFolio from "component/portfolio/PortFolio";
import Ourservice from "component/our-services/Ourservice";
import Home from "component/home/Home";
import PrivacyPolicy from "component/other/PrivacyPolicy";


function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/" element={<Home1 />} /> */}
          <Route path="/about-us" element={<About />} />
          <Route path="/our-service" element={<Ourservice />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/portfolio" element={<PortFolio />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/blog" element={<BlogHome />} />
          <Route path="/blog1" element={<Blogs />} />
          <Route path="/our-work" element={<OurWork />} />
          <Route path="/our-work/:projectName" element={<Project />} />
          <Route path="/carrer" element={<Carrer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
